import { isAuthChecker } from '@/router/middleware/isAuthChecker'

const auth = [
    {
        path: '/',
        component: () => import('@/components/Layout/AuthLayout.vue'),
        children: [
            {
                path: 'login',
                name: 'login',
                beforeEnter: [isAuthChecker],
                component: () => import('@/views/Auth/Login.vue'),
            },
            {
                path: 'register',
                children: [
                    {
                        path: '',
                        name: 'register',
                        component: () => import('@/views/Auth/Register.vue'),
                    },
                    {
                        path: 'code/:uuid',
                        name: 'register-code',
                        component: () => import('@/views/Auth/RegisterCode.vue'),
                    },
                    {
                        path: 'user/:uuid/password/:code',
                        name: 'register-password',
                        component: () => import('@/views/Auth/RegisterPassword.vue'),
                    },
                ],
            },
            {
                path: 'forgot',
                children: [
                    {
                        path: '',
                        name: 'forgot',
                        component: () => import('@/views/Auth/Forgot.vue'),
                    },
                    {
                        path: 'code',
                        name: 'forgot-code',
                        component: () => import('@/views/Auth/ForgotCode.vue'),
                    },
                    {
                        path: 'reset',
                        name: 'forgot-reset',
                        component: () => import('@/views/Auth/ForgotPassword.vue'),
                    },
                ],
            },
        ],
    },
]

export default auth
